import { render, staticRenderFns } from "./LessonLecture.vue?vue&type=template&id=c9dea9d2&scoped=true"
import script from "./LessonLecture.vue?vue&type=script&lang=js"
export * from "./LessonLecture.vue?vue&type=script&lang=js"
import style0 from "./LessonLecture.vue?vue&type=style&index=0&id=c9dea9d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9dea9d2",
  null
  
)

export default component.exports